var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{ref:"packagePosition",staticClass:"theme-bg",attrs:{"id":"package"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_vm._m(0),_c('div',{staticClass:"col-md-12 text-center"},[_c('swiper',{staticClass:"price-carousel",attrs:{"modules":_vm.modules,"navigation":true,"breakpoints":{
            '@0.50': {
              slidesPerView: 1,
              spaceBetween: 10,
            },
            '@0.75': {
              slidesPerView: 2,
              spaceBetween: 15,
            },
            '@1.25': {
              slidesPerView: 3,
              spaceBetween: 15,
            },
            '@1.50': {
              slidesPerView: 4,
              spaceBetween: 15,
            },
          },"slides-per-view":4,"loop":true,"space-between":15}},_vm._l((_vm.packages),function(pkg,index){return _c('swiper-slide',{key:index},[_c('div',{staticClass:"item"},[_c('div',{staticClass:"package-box"},[_c('h3',[_vm._v(_vm._s(pkg.type))]),_c('div',{staticClass:"price-box"},[_c('span',[_vm._v("$")]),_c('h2',[_vm._v(_vm._s(pkg.price))]),_c('h5',{staticClass:"plan-clr"},[_c('span',{staticClass:"d-block"},[_vm._v("Year")])])]),_c('div',{staticClass:"price-plan text-center"},[_c('ul',[_c('li',[_vm._v(_vm._s(pkg.feature1))]),_c('li',[_vm._v(_vm._s(pkg.feature2))]),_c('li',[_vm._v(_vm._s(pkg.feature3)+"nt")]),_c('li',[_vm._v(_vm._s(pkg.feature4))])]),_c('div',{staticClass:"price-plan-btn"},[_vm._v("Select Plan")])])])])])}),1)],1)])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-md-12 text-center"},[_c('div',{staticClass:"section-title"},[_c('h2',{staticClass:"text-white"},[_vm._v("Our Pricing Plans")]),_c('img',{staticClass:"img-fluid",attrs:{"src":require("../assets/images/white-line.png"),"alt":"title-line"}})])])
}]

export { render, staticRenderFns }